import {
  VlogCategoryCard,
  VlogPlaylistCard,
  VlogSectionHeading,
} from "@modules/study/common/vlog";
import { Grid, Pagination } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { Fragment, useEffect, useState } from "react";
import styles from "./vlog_all_category.module.scss";

const links = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Vlog",
    link: "/vlog",
  },
  {
    title: "All Category",
    link: "/vlog/category",
  },
];

const VlogAllCategory = ({ vlogCategories, vlogPlaylist }) => {
  const router = useRouter();

  const [paginate, setPaginate] = useState({
    currentPage: vlogCategories.currentPage,
    limit: vlogCategories.limit,
    page_total: vlogCategories.page_total,
    total: vlogCategories.total,
  });

  useEffect(() => {
    if (vlogCategories.currentPage) {
      setPaginate((prev) => ({
        ...prev,
        currentPage: vlogCategories.currentPage,
      }));
    }
  }, [vlogCategories.currentPage]);

  const paginationHandler = (e, page) => {
    e.preventDefault();
    router.push(`/vlog/category?limit=20&page=${page}`);
  };

  return (
    <Fragment>
      <VlogSectionHeading links={links} title="All Category" />
      <section>
        <div className="container">
          <Grid container spacing={4}>
            {vlogCategories &&
              vlogCategories?.results?.length > 0 &&
              vlogCategories?.results?.map((item, i) => (
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12} key={i}>
                  <VlogCategoryCard item={item} />
                </Grid>
              ))}
          </Grid>
          {paginate && paginate.total > paginate.limit && (
            <PaginationComponent
              paginate={paginate}
              paginationHandler={paginationHandler}
            />
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default VlogAllCategory;
